import { Colors } from "@zapier/design-system";

type Props = {
  isSelected?: boolean;
  fill?: string;
  height?: string;
  width?: string;
};

export function GroupIcon({
  isSelected = false,
  fill,
  height = "24",
  width = "24",
}: Props) {
  function getFill() {
    if (fill) {
      return fill;
    }
    if (isSelected) {
      return Colors.UiPrimaryStrongest;
    }
    return Colors.GrayWarm5;
  }
  const selectedFill = getFill();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3ZM5 0C2.23858 0 0 2.23858 0 5V19C0 21.7614 2.23858 24 5 24H19C21.7614 24 24 21.7614 24 19V5C24 2.23858 21.7614 0 19 0H5ZM13 10C13 9.44772 13.4477 9 14 9H18C18.5523 9 19 9.44772 19 10V14C19 14.5523 18.5523 15 18 15H14C13.4477 15 13 14.5523 13 14V10ZM6 9C5.44772 9 5 9.44772 5 10V14C5 14.5523 5.44772 15 6 15H10C10.5523 15 11 14.5523 11 14V10C11 9.44772 10.5523 9 10 9H6Z"
        fill={selectedFill}
      />
    </svg>
  );
}
